import { prepareUser } from 'shared/mappers/user';
import {
  IGetUserDataByRequestOptions,
  IGetUserDataByRequestResponse,
  IGetUserDataByRequestResponse200,
  IGetUserDataByRequestResponse400,
  IGetUserDataByRequestResponseError,
  fetchGetUserDataByRequest,
} from 'shared/repositories/monolith-python/v1/get-user-data-by-request';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { TUser } from 'shared/types/user';
import { assertResponseError } from 'shared/utils/errors';
import { request } from 'shared/utils/request';

type TParameters = TRequestParamsWithoutHttpApi<
  IGetUserDataByRequestOptions<IGetUserDataByRequestResponse200, IGetUserDataByRequestResponse400>
>;

export const fetchUser = async (context: IApplicationContext, parameters: TParameters): Promise<TUser> =>
  request<TUser, TParameters, IGetUserDataByRequestResponse, IGetUserDataByRequestResponseError>(context, {
    parameters,
    domain: 'fetchUser',
    fetchFunction: fetchGetUserDataByRequest,
    prepareFunction: prepareUser,
    errorHandler: assertResponseError,
    defaultValue: { isAuthenticated: false },
  });
